import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'common-bulma-modal',
    templateUrl: './bulma-modal.component.html',
    styleUrls: ['./bulma-modal.component.scss']
})
export class BulmaModalComponent implements OnInit {
    @Input() showModal = false;
    @Input() isWide = false;
    @Output() onHideModal = new EventEmitter();

    constructor() {}

    ngOnInit(): void {}

    public handleHideModal() {
        this.onHideModal.emit(true);
    }
}
